Object.defineProperty(exports,"__esModule",{value:true});exports.useNavigate=useNavigate;exports.useOpenDrawer=useOpenDrawer;exports.usePop=usePop;function useNavigate(props){
function navigate(route,pathname,opts,params){

if(props!=null&&props.navigate)props.navigate(route,opts);else

if(props!=null&&props.navigation)props.navigation.navigate(route,params);else

if(props.router){
props.router.push(pathname,route);
}
}
return navigate;
}

function usePop(props){
function pop(){

if(props!=null&&props.navigate)props.navigate('../',{replace:false});else

if(props!=null&&props.navigation)props.navigation.pop();else

if(props.router)props.router.back();
}
return pop;
}

function useOpenDrawer(props){
function openDrawer(drawerName){
if(props!=null&&props.navigate)props.navigate(drawerName||'Drawer');else
if(props!=null&&props.navigation)props.navigation.dispatch({type:'OPEN_DRAWER'});
}
return openDrawer;
}
//# sourceMappingURL=navigation.web.js.map